import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";

export const fetchFeedbackMobApp = createAsyncThunk(
    'contract/fetchFeedbackMobApp',
    async ({
        Name, Phone, Email, BirthDate, Description
    }: {
        Name: string;
        Phone: string;
        Email: string;
        BirthDate: string;
        Description: string;
    }, { rejectWithValue }) => {
        const requestBody = {
            Name: Name,
            Phone: Phone,
            Email: Email,
            BirthDate: BirthDate,
            Theme: "Удаление учетной записи",
            Description: Description,
        };
        try {
            const response = await getRequest(requestBody, 'max-bot', 'getFeedBackForm', 'POST');
            const data = await response.json();
            if (data.Error === 0) {
                return {
                    result: data.Error
                };
            } else {
                return {
                    Error: data.Errors,
                    Message: data.Message

                }
            }
        } catch (error: any) {
            return error.message;
        }
    }
);